/* src/pages/opportunitieslibrary/page-opportunities-library.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=page-opportunities-library.component-NKN4DXLS.css.map */
